export enum SurveySource {
  ExternalSurvey = 4,
  InternalSurvey = 5
}
